import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { TeamLineupsSponsorProvider } from 'common/react/components/team-lineups-sponsor/TeamLineupsSponsorProvider';

(function (app, common) {
    const SELECTORS = {
        SPONSOR_ELEMENT: '.js-team-lineups-sponsor'
    };

    common.TeamLineupsSponsor = class TeamLineupsSponsor {
        /**
         * Renders TeamLineupsSponsor react component with the dataset attributes values
         *
         * @param {HTMLElement} container Ancestor of the .js-team-lineups-sponsor element
         */
        constructor(container) {
            this.container = container;
            this.sponsorElement = this.container.querySelector(
                SELECTORS.SPONSOR_ELEMENT
            );

            if (this.sponsorElement) {
                this.render();
            }
        }

        render() {
            const root = createRoot(this.sponsorElement);
            root.render(
                createElement(TeamLineupsSponsorProvider, {
                    store: app.redux.store,
                    data: this.sponsorElement.dataset
                })
            );
        }
    };
})(PULSE.app, PULSE.app.common);
